import React from 'react';
import { UPLOAD_OR_DOWNLOAD_URL } from 'config/API_LINKS';
// import { PorfileNavigation } from 'features/profile/types';

const StudentDescription = ({
  // item,
  handleSwitch,
  data,
  setShowFullProfile,
}: {
  data: any;
  // item: PorfileNavigation;
  handleSwitch: (value: number) => void;
  setShowFullProfile: any;
}) => {
  const contactInfo = [
    {
      id: 1,
      logo: (
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.51667 6.99167C4.71667 9.35 6.65 11.2833 9.00833 12.4833L10.8417 10.65C11.075 10.4167 11.4 10.35 11.6917 10.4417C12.625 10.75 13.625 10.9167 14.6667 10.9167C14.8877 10.9167 15.0996 11.0045 15.2559 11.1607C15.4122 11.317 15.5 11.529 15.5 11.75V14.6667C15.5 14.8877 15.4122 15.0996 15.2559 15.2559C15.0996 15.4122 14.8877 15.5 14.6667 15.5C10.9094 15.5 7.30609 14.0074 4.64932 11.3507C1.99256 8.69391 0.5 5.09057 0.5 1.33333C0.5 1.11232 0.587797 0.900358 0.744078 0.744078C0.900358 0.587797 1.11232 0.5 1.33333 0.5H4.25C4.47101 0.5 4.68298 0.587797 4.83926 0.744078C4.99554 0.900358 5.08333 1.11232 5.08333 1.33333C5.08333 2.375 5.25 3.375 5.55833 4.30833C5.65 4.6 5.58333 4.925 5.35 5.15833L3.51667 6.99167Z'
            fill='#10ABB7'
          />
        </svg>
      ),
      info: data?.contactNumber,
    },
    {
      id: 2,
      logo: (
        <svg
          width='17'
          height='14'
          viewBox='0 0 17 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M15.3333 3.66536L8.66658 7.83203L1.99992 3.66536V1.9987L8.66658 6.16536L15.3333 1.9987M15.3333 0.332031H1.99992C1.07492 0.332031 0.333252 1.0737 0.333252 1.9987V11.9987C0.333252 12.4407 0.508847 12.8646 0.821407 13.1772C1.13397 13.4898 1.55789 13.6654 1.99992 13.6654H15.3333C15.7753 13.6654 16.1992 13.4898 16.5118 13.1772C16.8243 12.8646 16.9999 12.4407 16.9999 11.9987V1.9987C16.9999 1.0737 16.2499 0.332031 15.3333 0.332031Z'
            fill='#10ABB7'
          />
        </svg>
      ),
      info: data?.email,
    },
    {
      id: 3,
      logo: (
        <svg
          width='17'
          height='17'
          viewBox='0 0 17 17'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6.66654 0.667969H9.99988C10.4419 0.667969 10.8658 0.843563 11.1784 1.15612C11.4909 1.46868 11.6665 1.89261 11.6665 2.33464V4.0013H14.9999C15.4419 4.0013 15.8658 4.1769 16.1784 4.48946C16.4909 4.80202 16.6665 5.22594 16.6665 5.66797V14.8346C16.6665 15.2767 16.4909 15.7006 16.1784 16.0131C15.8658 16.3257 15.4419 16.5013 14.9999 16.5013H1.66654C0.741545 16.5013 -0.00012207 15.7513 -0.00012207 14.8346V5.66797C-0.00012207 4.74297 0.741545 4.0013 1.66654 4.0013H4.99988V2.33464C4.99988 1.40964 5.74154 0.667969 6.66654 0.667969ZM9.99988 4.0013V2.33464H6.66654V4.0013H9.99988Z'
            fill='#10ABB7'
          />
        </svg>
      ),
      info: data?.industryId?.title,
    },
    {
      id: 4,
      logo: (
        <svg
          width='12'
          height='18'
          viewBox='0 0 12 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6.00002 8.58464C5.44749 8.58464 4.91758 8.36514 4.52688 7.97444C4.13618 7.58374 3.91669 7.05384 3.91669 6.5013C3.91669 5.94877 4.13618 5.41886 4.52688 5.02816C4.91758 4.63746 5.44749 4.41797 6.00002 4.41797C6.55256 4.41797 7.08246 4.63746 7.47316 5.02816C7.86386 5.41886 8.08335 5.94877 8.08335 6.5013C8.08335 6.77489 8.02947 7.0458 7.92477 7.29856C7.82007 7.55132 7.66662 7.78099 7.47316 7.97444C7.2797 8.1679 7.05004 8.32135 6.79728 8.42605C6.54452 8.53075 6.27361 8.58464 6.00002 8.58464ZM6.00002 0.667969C4.45292 0.667969 2.96919 1.28255 1.87523 2.37651C0.781269 3.47047 0.166687 4.95421 0.166687 6.5013C0.166687 10.8763 6.00002 17.3346 6.00002 17.3346C6.00002 17.3346 11.8334 10.8763 11.8334 6.5013C11.8334 4.95421 11.2188 3.47047 10.1248 2.37651C9.03085 1.28255 7.54712 0.667969 6.00002 0.667969Z'
            fill='#10ABB7'
          />
        </svg>
      ),
      info: data?.country,
    },
  ];

  const imageUrl = data?.imageUrl
    ? UPLOAD_OR_DOWNLOAD_URL + '/' + data?.imageUrl
    : 'https://res.cloudinary.com/belong/image/upload/v1675236744/test/Upload_Placement_Profile_Hover_nmjf4j.svg';

  return (
    <div className='pt-2 pb-4 border-b px-6 border-b-primary'>
      {/* share and download icons */}
      <div className='flex justify-end'>
        <div className='flex '>
          {/* share icon */}
          {/* <svg
            width='42'
            height='34'
            viewBox='0 0 42 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect
              x='0.9'
              y='0.9'
              width='40.2'
              height='32.2'
              rx='4.1'
              fill='white'
            />
            <path
              d='M26.1458 25.4577C25.4514 25.4577 24.8611 25.2112 24.375 24.7181C23.8889 24.225 23.6458 23.6382 23.6458 22.9577C23.6458 22.8605 23.6562 22.7424 23.6771 22.6035C23.6979 22.4646 23.7292 22.3396 23.7708 22.2285L17.6458 18.666C17.4375 18.916 17.1736 19.1174 16.8542 19.2702C16.5347 19.423 16.2083 19.4993 15.875 19.4993C15.1806 19.4993 14.5903 19.2563 14.1042 18.7702C13.6181 18.2841 13.375 17.6938 13.375 16.9993C13.375 16.3049 13.6181 15.7146 14.1042 15.2285C14.5903 14.7424 15.1806 14.4993 15.875 14.4993C16.2083 14.4993 16.5278 14.5653 16.8333 14.6973C17.1389 14.8292 17.4097 15.0202 17.6458 15.2702L23.7708 11.7493C23.7292 11.6521 23.6979 11.5375 23.6771 11.4056C23.6562 11.2737 23.6458 11.1521 23.6458 11.041C23.6458 10.3466 23.8889 9.75629 24.375 9.27018C24.8611 8.78407 25.4514 8.54102 26.1458 8.54102C26.8403 8.54102 27.4306 8.78407 27.9167 9.27018C28.4028 9.75629 28.6458 10.3466 28.6458 11.041C28.6458 11.7355 28.4028 12.3257 27.9167 12.8118C27.4306 13.298 26.8403 13.541 26.1458 13.541C25.8125 13.541 25.4896 13.4855 25.1771 13.3743C24.8646 13.2632 24.6042 13.0896 24.3958 12.8535L18.2708 16.2285C18.2986 16.3396 18.3229 16.4716 18.3438 16.6243C18.3646 16.7771 18.375 16.9021 18.375 16.9993C18.375 17.0966 18.3646 17.2007 18.3438 17.3118C18.3229 17.423 18.2986 17.541 18.2708 17.666L24.3958 21.1243C24.6042 20.9299 24.8542 20.7702 25.1458 20.6452C25.4375 20.5202 25.7708 20.4577 26.1458 20.4577C26.8403 20.4577 27.4306 20.7007 27.9167 21.1868C28.4028 21.673 28.6458 22.2632 28.6458 22.9577C28.6458 23.6521 28.4028 24.2424 27.9167 24.7285C27.4306 25.2146 26.8403 25.4577 26.1458 25.4577ZM26.1458 12.166C26.4653 12.166 26.7326 12.0584 26.9479 11.8431C27.1632 11.6278 27.2708 11.3605 27.2708 11.041C27.2708 10.7216 27.1632 10.4542 26.9479 10.2389C26.7326 10.0237 26.4653 9.91602 26.1458 9.91602C25.8264 9.91602 25.559 10.0237 25.3437 10.2389C25.1285 10.4542 25.0208 10.7216 25.0208 11.041C25.0208 11.3605 25.1285 11.6278 25.3437 11.8431C25.559 12.0584 25.8264 12.166 26.1458 12.166ZM15.875 18.1243C16.1944 18.1243 16.4618 18.0167 16.6771 17.8014C16.8924 17.5862 17 17.3188 17 16.9993C17 16.6799 16.8924 16.4125 16.6771 16.1973C16.4618 15.982 16.1944 15.8743 15.875 15.8743C15.5556 15.8743 15.2882 15.982 15.0729 16.1973C14.8576 16.4125 14.75 16.6799 14.75 16.9993C14.75 17.3188 14.8576 17.5862 15.0729 17.8014C15.2882 18.0167 15.5556 18.1243 15.875 18.1243ZM26.1458 24.0827C26.4653 24.0827 26.7326 23.975 26.9479 23.7598C27.1632 23.5445 27.2708 23.2771 27.2708 22.9577C27.2708 22.6382 27.1632 22.3709 26.9479 22.1556C26.7326 21.9403 26.4653 21.8327 26.1458 21.8327C25.8264 21.8327 25.559 21.9403 25.3437 22.1556C25.1285 22.3709 25.0208 22.6382 25.0208 22.9577C25.0208 23.2771 25.1285 23.5445 25.3437 23.7598C25.559 23.975 25.8264 24.0827 26.1458 24.0827Z'
              fill='#10ABB7'
            />
            <rect
              x='0.9'
              y='0.9'
              width='40.2'
              height='32.2'
              rx='4.1'
              stroke='#10ABB7'
              stroke-width='0.2'
            />
          </svg> */}
          {/* download icon */}
          {/* <svg
            width='42'
            height='34'
            viewBox='0 0 42 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect
              x='0.9'
              y='0.9'
              width='40.2'
              height='32.2'
              rx='4.1'
              fill='white'
            />
            <path
              d='M21 20.0827C20.9028 20.0827 20.816 20.0688 20.7396 20.041C20.6632 20.0132 20.5833 19.9577 20.5 19.8743L17.2916 16.666C17.1528 16.5271 17.0868 16.3605 17.0937 16.166C17.1007 15.9716 17.1736 15.8049 17.3125 15.666C17.4653 15.5271 17.6389 15.4577 17.8333 15.4577C18.0278 15.4577 18.1944 15.5271 18.3333 15.666L20.2916 17.6452V10.6868C20.2916 10.4924 20.3611 10.3257 20.5 10.1868C20.6389 10.048 20.8055 9.97852 21 9.97852C21.2083 9.97852 21.3785 10.048 21.5104 10.1868C21.6423 10.3257 21.7083 10.4924 21.7083 10.6868V17.6452L23.6875 15.666C23.8264 15.5271 23.993 15.4577 24.1875 15.4577C24.3819 15.4577 24.5555 15.5271 24.7083 15.666C24.8472 15.8049 24.9166 15.9716 24.9166 16.166C24.9166 16.3605 24.8472 16.5271 24.7083 16.666L21.5 19.8743C21.4166 19.9577 21.3333 20.0132 21.25 20.041C21.1666 20.0688 21.0833 20.0827 21 20.0827ZM15.5 23.8952C15.125 23.8952 14.7951 23.7563 14.5104 23.4785C14.2257 23.2007 14.0833 22.8674 14.0833 22.4785V19.9785C14.0833 19.7841 14.1528 19.6174 14.2916 19.4785C14.4305 19.3396 14.6041 19.2702 14.8125 19.2702C15.0069 19.2702 15.1701 19.3396 15.3021 19.4785C15.434 19.6174 15.5 19.7841 15.5 19.9785V22.4785H26.4791V19.9785C26.4791 19.7841 26.5486 19.6174 26.6875 19.4785C26.8264 19.3396 27 19.2702 27.2083 19.2702C27.4028 19.2702 27.566 19.3396 27.6979 19.4785C27.8298 19.6174 27.8958 19.7841 27.8958 19.9785V22.4785C27.8958 22.8674 27.7569 23.2007 27.4791 23.4785C27.2014 23.7563 26.868 23.8952 26.4791 23.8952H15.5Z'
              fill='#10ABB7'
            />
            <rect
              x='0.9'
              y='0.9'
              width='40.2'
              height='32.2'
              rx='4.1'
              stroke='#10ABB7'
              stroke-width='0.2'
            />
          </svg> */}
          {/* edit icon */}
          <button
            onClick={() => {
              setShowFullProfile(false);
              handleSwitch(1);
            }}
          >
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M14.7583 3.36875C15.0833 3.04375 15.0833 2.50208 14.7583 2.19375L12.8083 0.24375C12.5 -0.08125 11.9583 -0.08125 11.6333 0.24375L10.1 1.76875L13.225 4.89375M0 11.8771V15.0021H3.125L12.3417 5.77708L9.21667 2.65208L0 11.8771Z'
                fill='#767676'
              />
            </svg>
          </button>
        </div>
      </div>
      {/* student image,name,title,linkedin */}
      <div className='flex  items-center'>
        {/* student image,name,title,contact info */}
        <div className='flex space-x-4 items-center '>
          <img
            src={imageUrl}
            alt='PP'
            className='h-24 w-24 lg:h-36 lg:w-36 object-contain rounded-full border border-primary'
          />
          <div className='lg:flex flex-wrap lg:justify-between space-y-2 lg:space-y-0 lg:w-[1000px] '>
            <div className='space-y-1 lg:space-y-2 '>
              <div className='flex space-x-4'>
                <p className='font-semibold'>
                  {data.firstName} {data.lastName}
                </p>
                {/* <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z'
                    fill='#10ABB7'
                  />
                </svg> */}
              </div>
              <div> {data.currentRole} </div>
            </div>
            {/* linkedin */}
            {data?.linkedInUrl && (
              <div className='mt-4 lg:mt-0 mr-8'>
                <a
                  href={data?.linkedInUrl}
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  <svg
                    width='18'
                    height='18'
                    viewBox='0 0 18 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16 0C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H16ZM15.5 15.5V10.2C15.5 9.33539 15.1565 8.5062 14.5452 7.89483C13.9338 7.28346 13.1046 6.94 12.24 6.94C11.39 6.94 10.4 7.46 9.92 8.24V7.13H7.13V15.5H9.92V10.57C9.92 9.8 10.54 9.17 11.31 9.17C11.6813 9.17 12.0374 9.3175 12.2999 9.58005C12.5625 9.8426 12.71 10.1987 12.71 10.57V15.5H15.5ZM3.88 5.56C4.32556 5.56 4.75288 5.383 5.06794 5.06794C5.383 4.75288 5.56 4.32556 5.56 3.88C5.56 2.95 4.81 2.19 3.88 2.19C3.43178 2.19 3.00193 2.36805 2.68499 2.68499C2.36805 3.00193 2.19 3.43178 2.19 3.88C2.19 4.81 2.95 5.56 3.88 5.56ZM5.27 15.5V7.13H2.5V15.5H5.27Z'
                      fill='#505050'
                    />
                  </svg>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* contact info,location */}
      <div className='grid md:grid-cols-2 lg:grid-cols-4 md:space-x-2 lg:gap-0 mt-2 lg:ml-40 lg:-mt-8'>
        {contactInfo.map((contact) => {
          return (
            <div
              key={contact.id}
              className='flex break-all space-x-3 items-center'
            >
              {contact.info ? (
                <>
                  <div className='h-4 w-4 object-contain'>{contact.logo}</div>
                  <p className='text-sm'>{contact.info}</p>
                </>
              ) : null}
            </div>
          );
        })}
      </div>
      {/* paragraph */}
      <div className='my-4 md:my-8'>
        <p>{data?.about}</p>
      </div>
    </div>
  );
};

export default StudentDescription;
